export default "__VITE_ASSET__hr6g4JxU__"